import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { HandleClickOutside } from '../../../../common/HandleClickOutside'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { UseTheme } from '../../../../common/hooks/useTheme'
import { UseTypeFontSize } from '../../../../common/hooks/useTypeFontSize'
import { getStyle } from '../../../../common/html/helper'
import { Icon } from '../../../../common/html/icon'
import { removeSpecials } from '../../../helper'
import { getHeaderSavedPortfolioDetail } from '../../../savedPortfolios/detailsPortfolios/store/thunk'
import { changeDataInRow } from '../../../savedPortfolios/portfoliosOverview/store/slice/slice'
import { putUpdateNamePortfolio } from '../../../savedPortfolios/portfoliosOverview/store/thunk'
import classes from './index.module.scss'

export const InputRename = ({
  containerStyle,
  inputRef,
  placeHolder,
  style,
  type,
  onBlur,
  onChange,
  onClick,
  defaultValue,
  setShowInput,
  isShowRenameOnly,
  setIsShowRename,
  setIsShowRenameOnly,
  bgColorIcon,
  isOnTable,
  colId,
  rowId,
  setName,
  ...props
}) => {
  const dispatch = useDispatch()
  const typeFontSize = UseTypeFontSize()
  const [searchId] = useSearchParams()
  const id = searchId.get('id')
  const theme = UseTheme()
  const [value, setValue] = useState(defaultValue || '')

  const onHandleClick = (event) => {
    onClick(event)
  }

  const closeRename = () => {
    setShowInput(false)
    setIsShowRename(false)
    setTimeout(() => setIsShowRenameOnly(false), 400)
  }

  const handleConfirm = () => {
    if (value.trim() === '') {
      return closeRename()
    }
    if (defaultValue !== value.trim()) {
      dispatch(
        putUpdateNamePortfolio({ portfolioId: rowId, portfolioName: value }),
      )
        .unwrap()
        .then(() => {
          if (isOnTable) {
            dispatch(
              changeDataInRow({ rowId: rowId, colId: colId, value: value }),
            )
          } else {
            dispatch(getHeaderSavedPortfolioDetail({ portfolioId: id }))
            setName(value)
          }
        })
        .catch(() => {})
    }
    closeRename()
  }

  const onHandleBlur = (event) => {
    onBlur(event)
  }

  const onHandleChange = (event) => {
    const valueReal = removeSpecials(event.target.value)
    onChange(valueReal)
    setValue(valueReal)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleConfirm()
    }
  }

  return (
    <div className="wh100">
      <HandleClickOutside handleClickOutside={closeRename}>
        <div
          ref={inputRef}
          className={classes.styleInput}
          style={containerStyle}
        >
          <input
            placeholder={UseI18n(placeHolder)}
            onClick={onHandleClick}
            onBlur={onHandleBlur}
            value={value}
            onChange={onHandleChange}
            onKeyDown={handleKeyDown}
            onFocus={(e) => {
              e.target.select()
            }}
            style={getStyle(
              {
                ...style,
              },
              theme,
              typeFontSize,
            )}
            type={type}
            {...props}
          />
          <div
            className={['dFlex gap1 alignItemsCenter'].join(' ')}
            style={{ width: '32px', backgroundColor: 'transparent' }}
          >
            <Icon
              className={['icon-delete', classes.iconItem].join(' ')}
              onClick={closeRename}
              style={{ color: '#9C9C9C', fontSize: 10 }}
            />
            <Icon
              className={['icon-tick', classes.iconItem].join(' ')}
              onClick={() => {
                handleConfirm()
              }}
              style={{ color: '#3DA967' }}
            />
          </div>
        </div>
      </HandleClickOutside>
    </div>
  )
}

InputRename.propTypes = {
  ref: PropTypes.object,
  placeHolder: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  defaultValue: PropTypes.string,
  setShowInput: PropTypes.func,
  bgColorIcon: PropTypes.string,
  setIsShowRename: PropTypes.func,
  setIsShowRenameOnly: PropTypes.func,
  isOnTable: PropTypes.bool,
  setName: PropTypes.func,
}

InputRename.defaultProps = {
  placeHolder: '',
  style: {},
  type: 'text',
  onBlur: () => {},
  onChange: () => {},
  onClick: () => {},
  defaultValue: '',
  setShowInput: () => {},
  bgColorIcon: '#ffffff',
  setIsShowRename: () => {},
  setIsShowRenameOnly: () => {},
  isOnTable: true,
  setName: () => {},
}
